// Import jQuery and jQuery Migrate.
import jQuery from 'jquery';
// import all jquery ui files
import 'jquery-ui-bundle';
import 'jquery-migrate/dist/jquery-migrate.min';

declare let window: any;

// assign jquery globals to window
window.$ = window.jQuery = jQuery;